import DocService from "@/modules/docs/DocService";

export default {
  namespaced: true,
  state: {
    loading: false,
    data: null
  },
  actions: {
    async loadData({commit}) {
      commit('setLoading', true);
      const result = await DocService.getData();
      if (result.success) {
        commit('setData', result.body);
      }
    },
  },
  mutations: {
    setData: (state, data) => {
      state.loading = false;
      state.data = data;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    }
  },
}
